var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0304 1.96982C19.7013 2.64082 20.0783 3.55089 20.0783 4.49982C20.0783 5.44875 19.7013 6.35882 19.0304 7.02982L7.06236 18.9998C6.78551 19.2768 6.44116 19.4767 6.06336 19.5798L0.947357 20.9748C0.819847 21.0094 0.685461 21.0097 0.557799 20.9757C0.430137 20.9416 0.31373 20.8745 0.220358 20.781C0.126987 20.6876 0.0599637 20.5711 0.0260724 20.4434C-0.00781894 20.3157 -0.0073758 20.1813 0.027357 20.0538L1.42236 14.9378C1.52546 14.56 1.72538 14.2157 2.00236 13.9388L13.9704 1.96982C14.6414 1.29883 15.5514 0.921875 16.5004 0.921875C17.4493 0.921875 18.3594 1.29883 19.0304 1.96982ZM13.0004 5.05982L3.06236 14.9998C2.97015 15.0921 2.90363 15.2069 2.86936 15.3328L1.81936 19.1828L5.66936 18.1328C5.79475 18.0977 5.90882 18.0305 6.00036 17.9378L15.9404 7.99982L13.0004 5.05982ZM15.0304 3.02982L14.0604 3.99982L17.0004 6.93982L17.9704 5.96982C18.3537 5.57861 18.5672 5.05191 18.5645 4.50417C18.5617 3.95643 18.3429 3.43191 17.9556 3.04459C17.5683 2.65728 17.0437 2.43846 16.496 2.43569C15.9483 2.43293 15.4216 2.64644 15.0304 3.02982Z",
    fill: "#68717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.148a9805be69e82c31dfd222c4d5e140.svg";
export { ForwardRef as ReactComponent };